import React from 'react';
import styled from 'styled-components';

import { Theme } from '../Theme';

import parse from 'react-html-parser';

export const HTMLContainer = styled.div`
	width: 100%;
	height: 100px;
	background: white;
	border-radius: 5px;
	padding: 16px 8px;
	resize: vertical;
	overflow: auto;
	scrollbar-width: thin;
	scrollbar-color: ${Theme.scrollThumb} ${Theme.scrollBar};
	&::-webkit-scrollbar {
		width: 5px;
		height: 5px;
	}
	&::-webkit-scrollbar-track {
		background: ${Theme.scrollBar};
	}
	&::-webkit-scrollbar-thumb {
		background: ${Theme.scrollThumb};
		border-radius: 8px;
	}
	&::-webkit-scrollbar-thumb:hover {
		background: ${Theme.scrollThumb};
	}
`;

export const HTMLViewer = ({ text }) => {
	return <HTMLContainer>{parse(text)}</HTMLContainer>;
};
